<div class="menu">
  <ng-container *ngFor="let item of menuStructure">
    <a appButton shape="round" name="{{item.text | lowercase}}" location="website-header" color="simple-gray" weight="bold"
      [routerLink]="item.link" [routerLinkActive]="'bc-simple-primary constant'" *ngIf="!item.dropdown"
      class="top-level-button">
      <span>{{item.text}}</span>
    </a>

    <app-context-menu [options]="{width: '520px', noSpacing: true, openOnHover: true, bigBorderRadius: true}"
      position="screen-center" #menu *ngIf="item.dropdown">
      <a contextButton appButton shape="round" name="{{item.text | lowercase}}" location="website-header" color="simple-gray"
        weight="bold" [routerLinkActive]="'bc-simple-primary constant'"
        [ngClass]="{'bc-simple-primary': isActive(item), 'constant': menu._isOpen || isActive(item)}"
        class="top-level-button">
        <span>{{item.text}}</span>
        <app-svg src="/assets/icons/16/arrow-down.svg" size="-1"></app-svg>
      </a>
      <div contextContent class="dropdown-menu">
        <ng-container *ngFor="let subItem of item.dropdown.items">
          <a name="website-header: {{subItem.text | lowercase}}" color="simple-gray" weight="bold"
            [routerLink]="subItem.link" [routerLinkActive]="'active'" *ngIf="subItem.link">
            <app-svg [src]="'/assets/icons/' + subItem.icon + '.svg'"></app-svg>
            <span>{{subItem.text}}</span>
          </a>

          <a name="website-header: {{subItem.text | lowercase}}" color="simple-gray" weight="bold"
            [href]="subItem.externalLink" target="_blank" *ngIf="subItem.externalLink">
            <app-svg [src]="'/assets/icons/' + subItem.icon + '.svg'"></app-svg>
            <span>{{subItem.text}}</span>
          </a>

        </ng-container>
      </div>
    </app-context-menu>
  </ng-container>
</div>
